import { DispatchTableEvent, DispatchTransactionEvent } from "../../events/events";
import {
  BUYORDERBOOK_TABLE,
  CLEAR_TABLE_DATA,
  EVENT_TOPIC_FOR_TRANSACTION_SERVER,
  EVENT_TYPE_DATAFEED_LOGOFF,
  EVENT_TYPE_TRANSACTION_LOGOFF,
  EXCHANGES_TABLE,
  HOLDINGS_TABLE,
  INSTRUMENTS_TABLE,
  JSON_KEY_MESSAGE_TYPE,
  JSON_KEY_USER,
  MARKETS_TABLE,
  MESSAGES_TABLE,
  NOTIFICATIONS_TABLE,
  ORDERS_FORM,
  PARTICIPANTS_TABLE,
  PUBLIC_TRADES_TABLE,
  RESULTS_TABLE,
  SELLORDERBOOK_TABLE,
  TRADING_ACCOUNTS_TABLE,
  TRADING_EVENTS_TABLE,
  TRADING_RULES_TABLE,
  USERS_ORDERS_TABLE,
  USERS_TABLE,
  USERS_TRADES_TABLE,
  confirmationDialog
} from "../../../common/common";
import globalsStore from "../../../redux/globalsStore";
import { MSGTYPE_DF_LOGOFF, MSGTYPE_TS_LOGOFF } from "../../../common/msg_types";
import { saveAllPanelPositionsForUser } from "../../../redux/panelPositionsSlice";


export const clearUserSessionAndTables = () => {
  // 1. Clear browser storage, except for out workspace layout
  Object.keys(localStorage).forEach((key) => {
    if (!key.startsWith('dashboard-workspace-') && !key.startsWith('tableStates_')) {
      localStorage.removeItem(key);
    }
  });

  sessionStorage.clear();

  // 2. Clear all relevant Redux table data
  const tableNames = [
    BUYORDERBOOK_TABLE, EXCHANGES_TABLE, HOLDINGS_TABLE, INSTRUMENTS_TABLE, MARKETS_TABLE, MESSAGES_TABLE,
    NOTIFICATIONS_TABLE, PARTICIPANTS_TABLE, PUBLIC_TRADES_TABLE, RESULTS_TABLE, SELLORDERBOOK_TABLE,
    TRADING_EVENTS_TABLE, TRADING_ACCOUNTS_TABLE, TRADING_RULES_TABLE, USERS_TABLE, USERS_ORDERS_TABLE,
    USERS_TRADES_TABLE, ORDERS_FORM
  ];

  tableNames.forEach(tableName => {
    DispatchTableEvent(CLEAR_TABLE_DATA, tableName, null);
  });
};

export const handleLogoff = async () => {
  const state = globalsStore.getState(); // ⬅️ Access redux globalsStore directly
  const df_user_id = state.globals.dfUserId;
  const ts_user_id = state.globals.tsUserId;
  const all_in_one_server = window.APP_CONFIG.ALL_IN_ONE_SERVER;

  const confirmed = await confirmationDialog({
    title: "Logoff?",
    text: "Are you sure you want to logoff?",
  });

  if (confirmed) {
    globalsStore.dispatch(saveAllPanelPositionsForUser(ts_user_id));

    if (!all_in_one_server) {
      const logoffDFProps = {
        [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_DF_LOGOFF,
        [JSON_KEY_USER]: df_user_id,
      };
      DispatchTransactionEvent(
        EVENT_TOPIC_FOR_TRANSACTION_SERVER,
        EVENT_TYPE_DATAFEED_LOGOFF,
        logoffDFProps
      );
    }

    const logoffTSProps = {
      [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_TS_LOGOFF,
      [JSON_KEY_USER]: ts_user_id,
    };

    DispatchTransactionEvent(
      EVENT_TOPIC_FOR_TRANSACTION_SERVER,
      EVENT_TYPE_TRANSACTION_LOGOFF,
      logoffTSProps
    );

    clearUserSessionAndTables();
  }
};
